import { createSelector } from "@reduxjs/toolkit";
const getParentWidget = (widgets, widgetId) => {
    const parentId = widgets[widgetId]?.parentId;
    return parentId ? widgets[parentId] : undefined;
};
const getFinalWidget = (presentWidget, widget, parentWidget) => {
    if (presentWidget) {
        return presentWidget;
    }
    if (parentWidget) {
        return { ...parentWidget, ...widget };
    }
    return widget;
};
export const widgetSelector = createSelector((state, widgetId) => state.designer.present?.widgets?.[widgetId], (state, widgetId) => state.entities.Widget[widgetId], (state, widgetId) => getParentWidget(state.entities.Widget, widgetId), getFinalWidget);
export const widgetsSelector = createSelector((state) => state.designer.present?.widgets, (state) => state.entities.Widget, (state, widgetIds) => widgetIds, (presentWidgets, entitiesWidgets, widgetIds) => {
    const res = [];
    if (!widgetIds) {
        return res;
    }
    for (const widgetId of widgetIds) {
        const presentWidget = presentWidgets?.[widgetId];
        const widget = entitiesWidgets[widgetId];
        const parentWidget = getParentWidget(entitiesWidgets, widgetId);
        const finalWidget = getFinalWidget(presentWidget, widget, parentWidget);
        if (finalWidget) {
            res.push(finalWidget);
        }
    }
    return res;
});
export const widgetChildrenIdsSelector = createSelector((state, widgetId) => widgetSelector(state, widgetId)?.componentProps?.childrenId, (state, widgetId) => widgetSelector(state, widgetId)?.componentProps?.widgets, (widgetChildrenId, widgetGroupedWidget) => {
    if (widgetGroupedWidget?.length > 0) {
        return widgetGroupedWidget;
    }
    if (widgetChildrenId) {
        return [widgetChildrenId];
    }
    return [];
});
